import SiteOwned from '@/models/SiteOwned'
import Site from '@/models/Site'
import Api from '@/services/api'
import { each, find } from 'lodash'
import router from '@/routes'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1
    },
    sitesOwned: {
      data: [],
      meta: {}
    },
    siteDetails: null
  },

  mutations: {
    setSiteList(state, sites) {
      each(sites, site => {
        const exist = find(state.list, { id: site.id })
        if (!exist) {
          state.list.push(new Site(site))
        }
      })
    },

    clearSiteList(state) {
      state.list = []
    },

    setSiteListMeta(state, meta) {
      state.listMeta = meta
    },

    setSiteDetails(state, site) {
      if (site instanceof Site) {
        state.siteDetails = site
      } else {
        state.siteDetails = new Site(site)
      }
    },
    setSitesOwned(state, sites) {
      each(sites, site => {
        const exist = find(state.list, { id: site.id })
        if (!exist) {
          state.list.push(new Site(site))
        }
      })
    },

    setSiteMapDetails(state, siteMap) {
      state.siteDetails.site_map = siteMap
    },
    clearSiteDetails(state) {
      state.siteDetails = null
    }
  },

  actions: {
    async getSites({ commit, rootState }, params) {
      const query =
        rootState.auth.user.user_role === 'SITE_OWNER'
          ? SiteOwned.page(params.page || 1)
          : Site.page(params.page || 1)

      if (params.search) {
        query.where('search', params.search)
      }

      const res = await query.params({ limit: params.limit || 20 }).get()

      commit('setSiteList', res.data)
      commit('setSiteListMeta', res.meta)
    },

    async getSiteDetails({ commit }, id) {
      const { data } = await Api.get(`sites/${id}`)
      commit('setSiteDetails', data.data)
    },

    async createSite({ commit }, formData) {
      const { data } = await Api.post(`sites`, formData)
      router.replace({
        name: 'site.details',
        params: {
          id: data.data.site_id
        }
      })
    },

    async updateSite({ commit }, formData) {
      const { data } = await Api.post(
        `sites/${formData.get('site_id')}?_method=PUT`,
        formData
      )
      commit('setSiteDetails', data.data)
    },

    async exportToExcel() {
      const file = await Api.get('/sites/export', { responseType: 'blob' })
      return file
    },

    async assignSparkiesToSite({ commit }, formData) {
      await Api.post(`sites/${formData.site_id}/users`, {
        users: formData.sparkies
      })
    },

    async removeSparkieToSite({ commit, rootState }, formData) {
      return Api.delete(`sites/${formData.site}/users/${formData.user}`)
    },

    async assignSitesToUser({ commit }, formData) {
      await Api.post(`users/${formData.user_id}/sites`, {
        sites: formData.sites
      })
    },

    async uploadSiteMap({ commit }, formData) {
      const { data } = await Api.post(
        `sites/${formData.get('site_id')}/map`,
        formData
      )
      commit('setSiteDetails', data.data)
    },

    async deleteSiteMap({ commit }, formData) {
      const { data } = await Api.delete(
        `sites/${formData.site_id}/map/${formData.site_map_id}`
      )
      commit('setSiteMapDetails', data.data.site_map)
    }
  }
}
